import { RouteObject } from 'react-router-dom';
import { appPaths } from 'consts/paths/paths';
import { AccountLayout } from 'components/layouts';
import {
    OwnerAndEmployeeAccountDetailsPage,
    OwnerAccountEditPage,
    PasswordUpdatePage,
} from 'pages';
import { AppActions } from 'types';
import { ROLE_BASED_PERMISSIONS_NAME } from 'consts/permissions/permissions';
import { AbilityRoute } from 'navigation/AbilityRoute/AbilityRoute';

export const accountRoutes: RouteObject[] = [
    {
        path: appPaths.app.account.base,
        element: <AccountLayout />,
        children: [
            // TODO: add page for parent role
            {
                path: appPaths.app.account.details.base,
                element: (
                    <AbilityRoute
                        can={{
                            action: AppActions.VIEW,
                            subject: ROLE_BASED_PERMISSIONS_NAME.ACCOUNT_DETAILS,
                        }}
                    >
                        <OwnerAndEmployeeAccountDetailsPage />
                    </AbilityRoute>
                ),
            },
            {
                path: appPaths.app.account['password-update'],
                element: <PasswordUpdatePage />,
            },
        ],
    },
    // TODO: add edit account data page for employee and parent roles
    {
        path: appPaths.app.account.details.edit,
        element: (
            <AbilityRoute
                can={{
                    action: AppActions.VIEW,
                    subject: ROLE_BASED_PERMISSIONS_NAME.ACCOUNT_DETAILS,
                }}
            >
                <OwnerAccountEditPage />
            </AbilityRoute>
        ),
    },
];
